module.exports = __webpack_public_path__ + "static/assets/d2bea2877a81351c11d73712ce9a06c9.png";